import { selectPreviousTabAction as selectPreviousTabOperation } from 'editor/src/store/editorModules/sidebar/slice';

export default selectPreviousTabOperation;
